import { MessageCircle, MapPin, Phone, Mail, Globe } from "lucide-react";
import { waLink } from "@/api";
import { useLang, tr } from "@/i18n";

export const Footer = ({ settings }) => {
    const { lang } = useLang();
    const t = (s) => tr(lang, s);
    const whatsapp = settings?.whatsapp || "919199335409";
    const logo = settings?.logo_data || "/logo.jpg";
    return (
        <>
            <footer data-testid="site-footer" className="bg-[#1C1613] border-t border-[#342A24] pt-14 pb-8">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <div className="flex items-center gap-3">
                        <img
                            src={logo}
                            alt="Dharm Sarovar logo"
                            data-testid="footer-logo-image"
                            className="h-12 w-12 rounded-xl object-cover border border-[#D4AF37]/50"
                        />
                        <span className="leading-tight">
                            <span className="block font-display font-semibold text-xl tracking-wide text-[#D4AF37]">
                                DHARM SAROVAR
                            </span>
                            <span className="block text-[10px] uppercase tracking-[0.32em] text-stone-400">
                                Private Limited
                            </span>
                        </span>
                    </div>
                    <p className="mt-5 text-sm text-stone-400 max-w-xl leading-relaxed">
                        {t("Dharm Sarovar Private Limited — authentic Pinddaan, Shradh & Tarpan rituals by traditional Gayawal Pandas at Gaya & Bodh Gaya, Bihar.")}
                    </p>

                    <p className="mt-8 text-sm font-semibold text-[#D4AF37]">{t("Contact")}</p>
                    <div className="mt-4 space-y-3.5 text-sm text-stone-300">
                        <p className="flex items-center gap-3">
                            <MapPin size={17} className="text-[#D4AF37] shrink-0" />
                            {t("Bodh Gaya, Bihar 823004, India")}
                        </p>
                        <a
                            href={waLink(whatsapp, "Namaste, I would like to know more about Gaya Pinddaan services.")}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="flex items-center gap-3 hover:text-amber-300 transition-colors"
                        >
                            <Phone size={17} className="text-[#D4AF37] shrink-0" />
                            +91 91993 35409
                        </a>
                        <a
                            href="mailto:dharmsarovar1@gmail.com"
                            data-testid="footer-email-link"
                            className="flex items-center gap-3 hover:text-amber-300 transition-colors"
                        >
                            <Mail size={17} className="text-[#D4AF37] shrink-0" />
                            dharmsarovar1@gmail.com
                        </a>
                    </div>

                    <p className="mt-8 text-sm font-semibold text-[#D4AF37]">{t("Also visit")}</p>
                    <a
                        href="https://dharmsarovar.in"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="footer-website-link"
                        className="mt-3 inline-flex items-center gap-2 text-sm text-amber-300 hover:text-amber-200 transition-colors"
                    >
                        <Globe size={15} /> dharmsarovar.in
                    </a>
                </div>
                <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-6 border-t border-[#342A24] flex flex-col sm:flex-row justify-between items-center gap-3">
                    <p className="text-xs text-stone-600">© {new Date().getFullYear()} Dharm Sarovar Private Limited. All rights reserved.</p>
                    <a href="/admin" data-testid="footer-admin-link" className="text-xs text-stone-600 hover:text-amber-300 transition-colors">
                        {t("Admin")}
                    </a>
                </div>
            </footer>

            <a
                href={waLink(whatsapp, "Namaste, I would like to know more about Gaya Pinddaan services.")}
                target="_blank"
                rel="noreferrer"
                data-testid="whatsapp-float-button"
                aria-label="Chat on WhatsApp"
                className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
            >
                <MessageCircle size={26} />
            </a>
        </>
    );
};
